//#region [IMPORT]

// === THIRD-PARTY ===
import React, {useContext, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import { Box      } from '@mui/material';

// === COMPONENTS ===
import { TaskPanel         } from './components/TaskPanel/index';
import { TaskCompleteModal } from './components/TaskCompleteModal';
import { TaskDashboard     } from './components/TaskDashboard/index';
import { AppContext } from 'pages/App/components/AppContext/AppContext';

// === HOOKS ===
import { useTaskWindows } from 'components/hooks/useTaskWindows/index';
import { useTaskStatus  } from 'components/hooks/useTaskStatus/index';

// === API ===
import { on, removeListener, sendMessageData } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function TaskVerification() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { user_details } = useContext( AppContext );

  const theme        = useTheme();
  const navigate     = useNavigate();
  const task_info    = useTaskStatus();

  const hasPermission = user_details.roles?.some((item) => item.RoleName === 'keyer');

  let page = localStorage.getItem('display_page');
  if( !page ) page = 'verify';

  //#endregion

  //#region [STYLES]
  
  const _styles = {
    container: {
      height: `calc(100% - 5rem)`,
      overflow  : 'hidden',
      'z-index' : '0',
      backgroundColor : theme.palette.background.secondary[theme.palette.mode],
    },
  }

  const
    CONTAINER = {
      sx: _styles.container,
    };

  //#endregion

  //#region [PROCES]

  useTaskWindows();

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function unsubscribe() {
      //-----------------------------------------------------------------
      sendMessageData( 'TASK_VIEW_PARENT_UNSUBSCRIBE' );
    }

    sendMessageData( 'TASK_VIEW_PARENT_SUBSCRIBING' );

    window.addEventListener('beforeunload', unsubscribe );
    return () => {
      window.removeEventListener('beforeunload', unsubscribe );
    }
  }, [] );

  useEffect( () => {
    function _handleReconnect(data) {
      sendMessageData( 'TASK_VIEW_PARENT_SUBSCRIBING', data );
    }

    on( 'connection', _handleReconnect );

    return () => {
      removeListener( 'connection', _handleReconnect );
    }
  }, [] );

  //#endregion

  //#region [green] Events

  if( user_details.roles.length === 0 ) {
    return null;
  }

  if( !hasPermission ) {
    navigate( '/' + page );
    window.location.reload(); 
  }
  
  //#endregion


  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    
    return (
      <Box { ...CONTAINER }>
        { task_info.has_task ? <TaskPanel /> : <TaskDashboard /> }
        <TaskCompleteModal />
      </Box>
    )
  }

  //#endregion

  return display();
}
